export const generateUniqueSlug = (name: string) => {
    // Convert to lowercase and replace spaces/special chars with hyphens
    const baseSlug = name
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-');
  
    // Add a random suffix to make it unique
    const randomSuffix = Math.random().toString(36).substring(2, 8);
    return `${baseSlug}-${randomSuffix}`;
  };